import styled, { useTheme } from "styled-components";

const Title = styled.label`
  margin-left: 10px;
  display: flex;
  text-align: start;
  font-size: ${(props) => props.theme.font.size.primary};
  font-weight: 600;
  color: ${(props) => props.theme.color.text.primary};
`;

const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  margin-top: 4px;
`;

const InfoText = styled.span`
  margin-top: 12px;
  text-align: start;
  font-size: ${(props) => props.theme.font.disclaimer};
  font-weight: ${(props) => props.weight || "600"};
  color: ${(props) => props.color};
`;

const Info = (props) => {
  const { color } = useTheme();

  return (
    <InfoContainer>
      <InfoText color={color.text.caption}>{props.caption}</InfoText>
      <InfoText
        color={color.text.primary}
        size={props.value && props.value.size}
        weight={props.value && props.value.weight}
      >
        {props.children}
      </InfoText>
    </InfoContainer>
  );
};

const CompleteButton = styled.button`
  font-weight: 600;
  font-size: ${(props) => props.theme.font.size.disclaimer};
  width: 100%;
  text-overflow: ellipsis;
  max-lines: 1;
  height: ${(props) => props.theme.coloredButtonHeight.primary};
  text-align: center;
  text-decoration: none;
  border: none;
  line-height: ${(props) => props.theme.coloredButtonHeight.primary};
  margin-top: 16px;
  color: ${(props) => props.theme.color.text.secondary};
  background-color: ${(props) => props.theme.color.accent};
  border-radius: 10px;
  cursor: pointer;
  &:hover {
    cursor: pointer;
    opacity: 90%;
  }
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const Back = styled.img`
  size: auto;
  cursor: pointer;
  &:hover {
    cursor: pointer;
    opacity: 90%;
  }
`;

export { Info, Title, CompleteButton, Back, TitleContainer };
